const t = {
  label2: {
    fontSize: "xs",
    lineHeight: "label",
    fontWeight: "regular"
  },
  label1: {
    fontSize: "sm",
    lineHeight: "label",
    fontWeight: "regular"
  },
  body: {
    fontSize: "md",
    lineHeight: "body",
    fontWeight: "regular"
  },
  headline2: {
    fontSize: "md",
    lineHeight: "headline2",
    fontWeight: "bold"
  },
  headline1: {
    fontSize: "xl",
    lineHeight: "headline1",
    fontWeight: "bold"
  },
  title4: {
    fontSize: "lg",
    lineHeight: "title4",
    fontWeight: "bold"
  },
  title3: {
    fontSize: "h4",
    lineHeight: "title3",
    fontWeight: "bold"
  },
  title2: {
    fontSize: "h3",
    lineHeight: "title2",
    fontWeight: "bold",
    letterSpacing: "largeTitle"
  },
  title1: {
    fontSize: "h2",
    lineHeight: "title1",
    fontWeight: "bold",
    letterSpacing: "largeTitle"
  },
  largeTitle: {
    fontSize: "h1",
    lineHeight: "largeTitle",
    fontWeight: "bold",
    letterSpacing: "largeTitle"
  }
}, i = {
  display: "inline-block",
  maxWidth: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, l = (e) => ({
  display: "-webkit-inline-box",
  WebkitLineClamp: String(e),
  WebkitBoxOrient: "vertical",
  overflow: "hidden"
}), n = {
  fontWeight: "inherit",
  fontSize: "inherit",
  lineHeight: "inherit"
}, o = {
  text: t,
  textEllipsis: i,
  textEllipsisMultiline: l,
  textInherit: n
};
export {
  o as textTheme
};
